<style>
  tr:hover td {
      background-color: #3F51B5;
  }
</style>
<template>
  <div>
	<h1 class="page-header mb-3">Active E7T Users</h1>
  <div class="row">
      <div class="col-xl-12">
        <div class="card border-0 mb-3 overflow-hidden bg-gray-800 text-white">
          <div class="card-body">
            <p>This is a raw list of active users of the deprecated apps on e7thunders.com.</p>
            <div v-if="loading" class="loading text-center"><div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div></div>
          <vue-good-table
            :columns="columns"
            v-if="rows && rows.length"
              :rows="rows"
            :lineNumbers="false"
            :search-options="{ enabled: true, skipDiacritics: true, placeholder: 'Search Current Table' }"
            :pagination-options="{ enabled: true,  position: 'bottom', perPage: 100, mode: 'pages' }"
            :selectOptions="{
              enabled: false,
              selectOnCheckboxOnly: true,
              selectionInfoClass: 'alert alert-info m-b-0 no-rounded-corner',
              selectionText: 'rows selected',
              clearSelectionText: 'clear',
            }"
            :sort-options="{
              enabled: true,
              multipleColumns: true,
//                initialSortBy: [{field: 'createdate', type: 'desc'}, {field: 'purchasedate', type: 'desc'}]
            }"
          >
          </vue-good-table>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import moment from 'moment';
//import AppOptions from '../config/AppOptions.vue';
import { useCookies } from "vue3-cookies";
import axios from "axios";


export default {
  name: 'e7tdash',
    setup() {
      const { cookies } = useCookies();
      return { cookies };
    },
    data() {
      return {

/*

SELECT user_id, u.first_name, u.last_name, u.email, u.paypal_email, p.name, access_start_date, access_end_date

FROM `dap_users_products_jn`

LEFT JOIN dap_users u ON dap_users_products_jn.user_id = u.id

LEFT JOIN dap_products p ON dap_users_products_jn.product_id = p.id

WHERE (product_id = 177 OR product_id = 190 OR product_id = 178 OR product_id = 189 OR product_id = 191 OR product_id = 192 OR product_id = 193 OR product_id = 194 OR product_id = 200 OR product_id = 201 OR product_id = 203 OR product_id = 251 OR product_id = 312)

ORDER BY access_end_date DESC, p.name;


 */


      loading: false,
        columns: [{
				label: 'UID',
				field: 'user_id',
				thClass: 'text-nowrap',
				tdClass: 'text-nowrap'
			}, {
				label: 'First Name',
				field: 'first_name',
				thClass: 'text-nowrap',
				tdClass: 'text-nowrap'
			}, {
				label: 'Last Name',
				field: 'last_name',
				thClass: 'text-nowrap',
				tdClass: 'text-nowrap'
			}, {
				label: 'Email',
        field: 'email',
				thClass: 'text-nowrap',
				tdClass: 'text-nowrap'
			}, {
        label: 'Paypal Email',
        field: 'paypal_email',
				thClass: 'text-nowrap',
				tdClass: 'text-nowrap'
			}, {
				label: 'Product Name',
				field: 'name',
				thClass: 'text-nowrap',
				tdClass: 'text-nowrap'
			}, {
				label: 'End Date',
        field: 'access_end_date',
        type: 'date',
        dateInputFormat: 'yyyy-MM-dd',
        dateOutputFormat: 'yyyy-MM-dd',
				thClass: 'text-nowrap',
				tdClass: 'text-nowrap'
			}, {
				label: 'Start Date',
        field: 'access_start_date',
        type: 'date',
        dateInputFormat: 'yyyy-MM-dd',
        dateOutputFormat: 'yyyy-MM-dd',
				thClass: 'text-nowrap',
				tdClass: 'text-nowrap'
			}],
      rows: null,
      }
    },
    methods: {
      fetchReportData()
      {
        this.error = null;
        this.loading = true;

        axios
          .post('https://api.destinycards.com/v1/reportadmin/e7tlist')
          .then(response => {
              this.rows = response.data.data;
              this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
      },
    },
    created() {
      this.fetchReportData();
    },
    mounted: function()
    {

    }
	}
</script>